import React from 'react';

interface SkeletonProps {
  className?: string;
}

export function Skeleton({ className = '' }: SkeletonProps) {
  return <div className={`skeleton ${className}`} aria-hidden="true" />;
}

export function SkeletonText({ lines = 1, className = '' }: { lines?: number; className?: string }) {
  return (
    <div className={`space-y-2 ${className}`} aria-hidden="true">
      {Array.from({ length: lines }).map((_, i) => (
        <div
          key={i}
          className="skeleton h-3 rounded"
          style={{ width: i === lines - 1 && lines > 1 ? '65%' : '100%' }}
        />
      ))}
    </div>
  );
}

export function SkeletonCard({ rows = 3 }: { rows?: number }) {
  return (
    <div className="card-elevated p-4 space-y-3" aria-hidden="true">
      <div className="flex items-center gap-3">
        <Skeleton className="w-9 h-9 rounded-xl" />
        <div className="flex-1 space-y-2">
          <Skeleton className="h-3.5 rounded w-2/5" />
          <Skeleton className="h-2.5 rounded w-3/5" />
        </div>
      </div>
      {Array.from({ length: rows - 1 }).map((_, i) => (
        <Skeleton key={i} className={`h-3 rounded ${i === rows - 2 ? 'w-4/5' : 'w-full'}`} />
      ))}
    </div>
  );
}

export function SkeletonScreen() {
  return (
    <div className="space-y-4 pt-2 px-[14px] fade-in" aria-hidden="true">
      {/* Hero card */}
      <div className="skeleton rounded-[20px] h-32" />
      {/* KPI strip */}
      <div className="flex gap-3 overflow-hidden">
        {[1, 2, 3].map(i => (
          <div key={i} className="skeleton rounded-2xl h-20 min-w-[132px]" />
        ))}
      </div>
      {/* Content cards */}
      <SkeletonCard rows={4} />
      <SkeletonCard rows={3} />
    </div>
  );
}
